import utils from "./utils";
import Http from "./http";

const UPLOAD_URI = 'https://upload.qiniup.com';
const UPLOAD_AUTH_URI = 'member/member/qiniu/auth';

const Upload = (function () {
    var _tokens;

    class UploadManager {
        constructor() {
            _tokens = {};
        }
        /** 
         * 开始上传任务
         * @param {Array} tasks
         */
        startTasks(tasks = []) {
            return Promise.all(tasks);
        }
        /**
         * 上传文件列表
         * @param {Array} list
         * @param {Array} prefix
         */
        startUpload(list = [], prefix = []) {
            return Promise.all(list.map(_ => this.upload(_, prefix)));
        }
        /**
         * 文件上传
         * @param {Object} file
         * @param {Array} prefix
         */
        async upload(file, prefix = [], isRetry = false, suffix = ".png") {
            if (!file) {
                return Promise.resolve('');
            }
            let disk = prefix[0];
            if (!_tokens[disk]) {
                await updateToken(disk);
            }
            // let suffix = '.png';
            let formData = new FormData();
            formData.append('key', getFileName(prefix) + suffix);
            formData.append('token', _tokens[disk]);
            formData.append('file', file);

            return new Promise((resolve, reject) => {
                Http.post(UPLOAD_URI, formData, {
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                }).then(res => {
                    let temp = res.url + '/' + res.key;
                    resolve(temp);
                }).catch(async err => {
                    if (err.response.status === 401 && !isRetry) {
                        await updateToken(disk);
                        this.upload(file, prefix, true).then(res => resolve(res)).catch(() => reject());
                    } else {
                        console.error('文件上传失败', file, err);
                        reject(err.data || err.status);
                    }
                })
            })
        }
    }

    /**
     * 获取文件名
     * @param {*} prefix 
     * @returns 
     */
    function getFileName(prefix) {
        let temp = [...prefix];
        let now = utils.dateFmt('YmdHisu', new Date());
        let random = Math.floor(Math.random() * 999).toString().padStart(3, '0');
        temp.push(now + random);
        return temp.join('-');
    }

    /**
     * 更新token
     * @param {String} disk 空间标识
     */
    function updateToken(disk) {
        return Http.post(UPLOAD_AUTH_URI, {
            disk
        }, {
            headers: {
                'authorization': localStorage.getItem('_token') || undefined
            },
            cancelable: false,
        }).then(res => {
            _tokens[disk] = res.token;
        }).catch(err => {
            console.error('文件上传授权失败', disk, err);
            throw '文件上传授权失败';
        })
    }

    return new UploadManager();
})();

export default Upload;